<template>
  <van-popup
    class="delivery-confirm"
    :close-on-click-overlay="false"
    :closeable="false"
    v-model="shown"
    @closed="onClosed"
  >
    <div class="delivery-confirm-header c:row-center">
      <div class="delivery-confirm-header-icon"></div>
      <div class="delivery-confirm-header-title">下单成功</div>
      <div class="delivery-confirm-header-icon" @click="hide">
        <img src="@/assets/icons/closer.svg" alt="" />
      </div>
    </div>
    <div class="delivery-confirm-body">
      <div class="delivery-confirm-items">
        <div class="delivery-confirm-item c:row-between-center">
          <div class="delivery-confirm-item-label">快递公司</div>
          <div class="delivery-confirm-item-value">{{ logisticsCompany }}</div>
        </div>
        <div class="delivery-confirm-item c:row-between-center">
          <div class="delivery-confirm-item-label">快递单号</div>
          <div class="delivery-confirm-item-value">{{ logisticsNo }}</div>
        </div>
        <div class="delivery-confirm-item c:row-between-center">
          <div class="delivery-confirm-item-label">预估费用</div>
          <div class="delivery-confirm-item-value">
            {{ logisticsEstimatedPrice }}
          </div>
        </div>
      </div>
      <div class="delivery-confirm-buttons c:row-center">
        <CButton small primary :disabled="false" @click="onConfirm"
          >确定</CButton
        >
      </div>
    </div>
  </van-popup>
</template>

<script>
import CButton from "@/components/common/CButton.vue";
import { outputmoney } from "@/utils";

export default {
  components: { CButton },
  data() {
    return {
      shown: false,
      isShowSheet: false,
      logisticsCompany: "",
      logisticsNo: "",
      logisticsEstimatedPrice: "",
    };
  },
  methods: {
    show({ logisticsCompany, logisticsNo, logisticsEstimatedPrice }) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve;
        this._reject = reject;
        this.logisticsCompany = logisticsCompany;
        this.logisticsNo = logisticsNo;
        this.logisticsEstimatedPrice =
          typeof logisticsEstimatedPrice === "number"
            ? `￥ ${outputmoney(logisticsEstimatedPrice)}`
            : "待快递确认";
        this.shown = true;
      });
    },
    hide() {
      this.shown = false;
    },
    onClosed() {
      if (this._reject) {
        this._reject();
        this._resolve = null;
        this._reject = null;
      }
    },
    onConfirm() {
      if (this._resolve) {
        this._resolve();
        this._resolve = null;
        this._reject = null;
      }
      this.shown = false;
    },
  },
};
</script>

<style lang="less" scoped>
.delivery-confirm {
  width: 320/20rem;
  min-height: 100/20rem;
  border-radius: 16/20rem;

  &-header {
    gap: 6/20rem;

    box-sizing: border-box;
    width: 100%;
    height: 38/20rem;
    padding: 10/20rem 10/20rem 6/20rem;

    &-title {
      flex: 1;
      width: 0;
      height: 20/20rem;
      line-height: 20/20rem;
      font-weight: 500;
      font-size: 16/20rem;
      letter-spacing: 0;
      text-align: center;
      color: #000;
    }
    &-icon {
      width: 22/20rem;
      height: 22/20rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  &-items {
    box-sizing: border-box;
    padding: 0rem 20/20rem;
  }
  &-item {
    gap: 6/20rem;

    height: 46/20rem;
    border-bottom: 1px solid #e4e4e4;

    &-label {
      line-height: 18/20rem;
      font-weight: 400;
      font-size: 14/20rem;
      letter-spacing: 0;
      color: #000;
    }

    &-value {
      line-height: 17/20rem;
      font-weight: 400;
      font-size: 12/20rem;
      letter-spacing: 0;
      text-align: right;
      color: #7d7d7d;
    }
  }
  &-buttons {
    gap: 12/20rem;

    box-sizing: border-box;
    margin-top: 6/20rem;
    margin-bottom: 13/20rem;
    padding: 16/20rem 20/20rem 20/20rem;
  }
}
</style>
